import React from 'react'
import { NavBar,Icon,Tabs  } from 'antd-mobile';
import "./contenthome.scss"
import {} from "../../api/index"
import {HashRouter, Route, Switch,Redirect } from 'react-router-dom';
import HomePageStatistics from '../HomePageStatistics/HomePageStatistics'
import RepertoryWarning from '../repertoryWarning/repertoryWarning'
import ProductSale from '../productSale/productSale'
import ProductAchievement from '../productAchievement/productAchievement'
import MarketingPerformance from '../marketingPerformance/marketingPerformance'
import Monitoring from '../monitoring/monitoring'
import SampleOrder from '../sampleOrder/sampleOrder'
export default class Contenthome extends React.Component{
    constructor(props){
        super(props)
        this.state={
            tabArr:[],
            activeLiId:null,
            activeTabInfo:{}
        }
    }
    changeActive(s){
        this.setState({
            activeLiId:s.id,
            activeTabInfo:s
        });
        this.props.history.push(s.url);
    }
    goHome(){
        this.props.history.replace({pathname:"/TopHome"})
    }
    render(){
        
        return (
            <div className="contenthome">
                <div className='infoTop'>
                    {/* <NavBar
                        
                        mode="dark"
                        icon={<Icon type="left" />}
                    >{this.state.activeTabInfo.name||""}</NavBar> */}
                    <div className='navbar'>
                        <p>
                            <Icon onClick={()=>{this.goHome()}} style={{flex:1,color:'#fff',textAalign:'left'}} type="left" size="md"  />
                        </p>
                        
                        <span  style={{textAalign:'center',color:'#fff'}} >{this.state.activeTabInfo.name||""}</span>
                        <div></div>
                    </div>
                    <div class="tabsTop">
                        <ul>
                            {
                                this.state.tabArr.map((s)=>{
                                    return <li onClick={()=>{this.changeActive(s)}} className={this.state.activeLiId==s.id?"activeli":''} key={s.id}>
                                        <span>{s.name}</span>
                                        <div></div>
                                    </li>
                                })
                            }
                        </ul>
                    </div>
                    <div className="styleDiv"></div>
                </div>
                <div className="TabContent">
                    <HashRouter>
                        <Switch>
                            <Route exact path="/msite/home" component={HomePageStatistics}/>
                            <Route exact path="/msite/repertoryWarning" component={RepertoryWarning}/>
                            <Route exact path="/msite/productSales" component={ProductSale}/>
                            <Route exact path="/msite/marketingPerformance" component={MarketingPerformance}/>
                            <Route exact path="/msite/productAchievement" component={ProductAchievement}/>
                            <Route exact path="/msite/monitoring" component={Monitoring}/>
                            <Route exact path="/msite/sampleorder/reserveApply" component={SampleOrder}/>
                        </Switch>
                    </HashRouter>       
                </div>
                
            </div>
        )
    }
    componentDidMount(){
        console.log("this.state.activeLiId",this.state.activeLiId)
        let json=JSON.parse(sessionStorage.getItem("tabArr"));
        console.log("json",json)
        this.setState({
            tabArr:json,
            activeLiId:json[0].id,
            activeTabInfo:json[0]
        },()=>{
            let topDiv=document.getElementsByClassName("infoTop")[0]
            let contentDiv=document.getElementsByClassName("TabContent")[0]
            contentDiv.style.position='relative';
            contentDiv.style.top=topDiv.clientHeight+"px";
            contentDiv.style.left="0px";
            contentDiv.style.width="100%";
        })
        
    }
}